import React, { useState } from 'react';
import {
  PDFViewer,
  Document,
  Page,
  Image,
  Text,
  View,
  StyleSheet,
  Font,
} from '@react-pdf/renderer';
import Cu from '../../assets/images/cu-logo-head.png';
import CuTree from '../../assets/images/cu-logo-tree-foot.png';
import CuFoot from '../../assets/images/cu-logo-foot.png';
import MyBoldFont from '../../assets/Lato-Black.ttf';
import MyBoldFontStyle from '../../assets/Lato-Bold.ttf';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getTCDetails } from '../../Pages/TransactionCertificate/TransactionCertificateSlice';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { QRCodeCanvas } from 'qrcode.react';
import { QRCodeSVG } from 'qrcode.react';

Font.register(
  {
    family: 'MyFont',
    src: MyBoldFont,
    fontWeight: 'bold',
  },
  {
    family: 'Roboto',
    src: MyBoldFontStyle,
    fontWeight: 'bold',
  }
);

const styles = StyleSheet.create({
  document: {
    display: 'flex',
  },
  page: {
    flexDirection: 'row',
    backgroundColor: '#fff',
  },
  pageWrapper: {
    paddingBottom: 135,
    marginTop: 20,
    paddingTop: 150,
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 90,
  },
  content: {
    position: 'absolute',
    top: 61,
    left: 0,
    right: 0,
    padding: 30,
  },
  footer: {
    position: 'absolute',
    height: 135,
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    display: 'table',
    width: 'auto',
    marginTop: '25px',
    // borderWidth: "2px",
    // borderColor: "black",
    border: '1px solid black',
  },
  tableHead: {
    margin: 'auto',
    flexDirection: 'row',
    fontWeight: 'bold',
    border: '1px solid black',
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    textAlign: 'left',
    border: '1px solid black',
  },
  tableCol: {
    width: '35%',
    border: '1px solid black',
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 8,
    border: '1px solid black',
    // borderWidth: "2pt",
    // borderColor: "black",
    // borderStyle: "solid",
  },
  tableHeader: {
    fontWeight: 'bold',
    fontSize: 10,
    padding: 5,
    borderLeft: '1px solid black',
  },
  tableCellTc: {
    fontSize: 8,
    padding: 5,
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
  },
  tableContainer: {
    marginVertical: 10,
    marginHorizontal: 20,
  },
  headerCell: {
    backgroundColor: '#ECECEC',
    padding: 5,
    fontWeight: 'bold',
  },
  dataCell: {
    padding: 5,
  },
  QRImage: {
    width: '60px',
    height: '60px',
    marginTop: 5,
    marginBottom: 10,
    marginLeft: 20,
  },
});

const MyHeader = () => {
  return (
    <View style={styles.header} fixed>
      <View>
        <Image src={Cu} style={{ width: '60', height: '60', margin: 'auto' }} />
      </View>
    </View>
  );
};

const MyFooter = ({ tc, qrCodeDataUri }) => {
  return (
    <View style={styles.footer} fixed>
      <View
        style={{
          width: '100%',
          height: '1px',
          border: '1 solid black',
        }}
      ></View>
      <View
        style={{
          fontSize: '9px',
          marginTop: '5',
          textAlign: 'center',
          paddingHorizontal: '40',
        }}
      >
        <Text>
          This electronically issued document is the valid original version.
          Please scan the QR-code to verify the integrity of this document. In
          view of possible hacking, the QR code of this certificate should
          always link to a website under the following domain: controlunion.com.
          If the QR code points to any other website, the certificate is forged.
        </Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: '11px',
          marginTop: '',
          paddingHorizontal: '40',
          justifyContent: 'space-evenly',
        }}
      >
        <View style={{ width: '20%' }}>
          <Image src={Cu} style={{ width: '60', height: '60', margin: 'auto' }} />
        </View>
        <View
          style={{
            width: '60%',
            borderLeft: '1px solid black',
            paddingLeft: '5px',
            marginTop: '5px',
          }}
        >
          <Text>CU Inspections & Certifications India Pvt. Ltd. </Text>
          <View style={{ marginTop: '2' }}>
            <Text>
              {' '}
              <Text style={{ color: 'blue' }}>POST -</Text>{' '}
              <Text>
                {' '}
                22nd Floor,Arihant Aura, TTC Industrial Area, Turbhe MIDC,
                Opposite Turbhe Station, • 400705 • Navi Mumbai
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: 'row',
              fontSize: '11px',
              marginTop: '2',
              justifyContent: 'left',
            }}
          >
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ color: 'blue' }}> T -</Text>
              <Text> +91 22 61294200</Text>
            </View>
            <View style={{ flexDirection: 'row', marginLeft: '5px' }}>
              <Text style={{ color: 'blue' }}>F -</Text>
              <Text> cuindia@controlunion.com</Text>
            </View>
          </View>
        </View>
        <View>
          {qrCodeDataUri && (
            <Image
              allowDangerousPaths
              src={qrCodeDataUri}
              style={styles.QRImage}
            />
          )}
        </View>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: '8px',
          marginTop: '5px',
          textAlign: 'center',
          justifyContent: 'center',
          paddingHorizontal: '40',
        }}
      >
        <View>
          <Text>Transaction Certificate Number: {tc?.tcApplicationNumber}</Text>
        </View>
        <View style={{ marginLeft: '5' }}>
          <Text>Seller Licence Number: {tc?.tc_seller?.license}</Text>
        </View>
      </View>
    </View>
  );
};

const MyDocument = ({ tc }) => {
  const PageWrapper = ({ children }) => {
    return (
      <Page size="Letter" style={styles.pageWrapper}>
        <MyHeader tc={tc} />
        <View style={styles.content}>{children}</View>
        <MyFooter tc={tc} qrCodeDataUri={qrCodeDataUri} />
      </Page>
    );
  };
  // const [qrCodeDataUri, setQrCodeDataUri] = useState(null);

  const currentDate = new Date();

  // Format the date in dd/mm/yyyy format
  const formattedDate = currentDate.toLocaleDateString('en-GB');

  // useEffect(() => {
  //   // Generate QR code with URL value
  //   const qrCodeValue = 'https://www.example.com';
  //   const qrCodeCanvas = document.createElement('canvas');
  //   new QRCode(qrCodeCanvas, { value: qrCodeValue });
  //   const dataUri = qrCodeCanvas.toDataURL('image/jpg', 0.3);
  //   setQrCodeDataUri(dataUri);
  // }, []);

  const [qrCodeDataUri, setQrCodeDataUri] = useState(null);

  const generateQrCode = (id) => {
    if (id) {
      const qrCodeValue = `${process.env.REACT_APP_API_HOST}/traceability/${tc?.tcNumber}`;
      const apiUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
        qrCodeValue
      )}&size=256x256`;

      fetch(apiUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            setQrCodeDataUri(reader.result);
          };
          reader.readAsDataURL(blob);
        });
    }
  };

  useEffect(() => {
    // Generate QR code with URL value
    generateQrCode(tc?._id);
  }, [tc?._id]);



  return (
    <Document>
      <PageWrapper>
        {/* <View style={{ display: "none" }}>
          <QRCodeSVG
            id="qr-code"
            value={`https://staging-cui-trace.emertech.io/${tc?._id}`}
            size={128}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"L"}
            includeMargin={false}
          />
        </View> */}
        <View>
          <View
            style={{
              textAlign: "center",
              paddingHorizontal: "50",
              fontSize: "15px",
              fontWeight: "bold",
            }}
          >
            <Text style={{ fontFamily: "MyFont", fontWeight: "bold" }}>
              {`TRANSACTION CERTIFICATE (TC) FOR TEXTILES PROCESSED ACCORDING TO ${tc?.tc_program?.name?.toUpperCase()}`}
            </Text>
          </View>
          <View style={{ border: "2px solid black", marginTop: "10px" }}>
            <View style={{ height: "150px", flexDirection: "row" }}>
              <View
                style={{
                  width: "49%",
                  paddingHorizontal: "20",
                  marginTop: "5",
                }}
              >
                <Text
                  style={{
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  {"1a) Body issuing the certificate:"}
                </Text>
                <Text style={{ fontSize: "10px", marginTop: "5" }}>
                  {tc?.tc_certificationBody?.name ||
                    `CU Inspections & Certifications India Pvt. Ltd.
                    22nd Floor,Arihant Aura, TTC Industrial Area, Turbhe
                    MIDC, Opposite Turbhe Station,
                    400705 Navi Mumbai
                    India`}
                </Text>
              </View>
              <View style={{ width: "51%", borderLeft: "1px solid black" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"2a) Reference number of the certificate:"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tcNumber}
                  </Text>
                </View>
                <View
                  style={{ marginTop: "80px", borderTop: "1px solid black" }}
                >
                  <View style={{ marginTop: "10px", paddingLeft: "2px" }}>
                    <Text
                      style={{
                        fontSize: "10px",
                        fontFamily: "MyFont",
                        fontWeight: "bold",
                      }}
                    >
                      {"2b) Reference number of the input certificate:"}
                    </Text>
                    <Text style={{ fontSize: "10px", marginTop: "5" }}>
                      {tc?.parentTCs?.length > 0
                        ? tc?.parentTCs?.map((el) => {
                            return <Text>{el}</Text>;
                          })
                        : "NA"}
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View
              style={{
                height: "100px",
                flexDirection: "row",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ width: "49%" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"3) Seller of the product:"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_seller?.name}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_seller?.address?.raw_address},{" "}
                    {tc?.tc_seller?.address?.city},{" "}
                    {tc?.tc_seller?.address?.state},{" "}
                    {tc?.tc_seller?.address?.country},
                    {tc?.tc_seller?.address?.pinCode}
                  </Text>
                </View>
              </View>
              <View style={{ width: "51%", borderLeft: "1px solid black" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"4) Inspection body:"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_inspectionBody?.name ||
                      `CU Inspections & Certifications India Pvt. Ltd.
                                        22nd Floor,Arihant Aura, TTC Industrial Area, Turbhe
                                        MIDC, Opposite Turbhe Station,
                                        400705 Navi Mumbai
                                        India`}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                height: "100px",
                flexDirection: "row",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ width: "49%" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"5) Last processor of the product:"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_lastProcessor?.name ||
                      tc?.lastProcessorDetails?.name}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_lastProcessor?.address?.raw_address ||
                      tc?.lastProcessorDetails?.address}
                  </Text>
                </View>
              </View>
              <View style={{ width: "51%", borderLeft: "1px solid black" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"6) Country of dispatch"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_seller?.address?.country ||
                      tc?.sellerDetails?.country}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                height: "167px",
                flexDirection: "row",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ width: "49%", borderBottom: "1px solid black" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"7) Buyer of the product(s) (name and address):"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "10" }}>
                    {tc?.tc_buyer?.name || tc?.buyerDetails?.name}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_buyer?.address?.raw_address ||
                      tc?.buyerDetails?.address}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  width: "51%",
                  borderLeft: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"8) Consignee of the product:"}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "10" }}>
                    {tc?.tc_consignee?.name || tc?.consigneeDetails?.name}
                  </Text>
                  <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {tc?.tc_consignee?.address?.raw_address ||
                      (tc?.consigneeDetails?.address &&
                      tc?.consigneeDetails?.country
                        ? `${tc?.consigneeDetails?.address}, ${tc?.consigneeDetails?.country}`
                        : tc?.consigneeDetails?.address)}
                  </Text>
                </View>
                <View
                  style={{ marginTop: "30px", borderTop: "1px solid black" }}
                >
                  <View style={{ paddingHorizontal: "10" }}>
                    <Text
                      style={{
                        fontSize: "12px",
                        marginTop: "5",
                        fontFamily: "MyFont",
                        fontWeight: "bold",
                      }}
                    >
                      {"9) Country of destination:"}
                    </Text>
                    <Text style={{ fontSize: "10px", marginTop: "5" }}>
                      {tc?.tc_buyer?.address?.country || tc?.tc_buyer?.country}
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View
              style={{
                height: "100px",
                flexDirection: "row",
                borderTop: "1px solid black",
              }}
              break
            >
              <View style={{ width: "70%" }}>
                <View style={{ paddingHorizontal: "20", marginTop: "5" }}>
                  <Text
                    style={{
                      fontSize: "12px",
                      marginTop: "5",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"10) Product and shipment information:"}
                  </Text>
                  <Text style={{ fontSize: "8px", marginTop: "5" }}>
                    {"Information is presented in box 17 on page 2 of this TC"}{" "}
                  </Text>

                  {/* <Text style={{ fontSize: "10px", marginTop: "5" }}>
                    {" "}
                    Undyed fibers: 100% Lint Cotton{" "}
                  </Text>
                  <Text style={{ fontSize: "10px" }}>
                    {" "}
                    Invoices: xxx Dated on YYYY-MM-DD{" "}
                  </Text>
                  <Text style={{ fontSize: "10px" }}>
                    {" "}
                    Shipment Doc No: XXXXXXXXXXX{" "}
                  </Text>
                  <Text style={{ fontSize: "10px" }}>
                    {" "}
                    Shipment Date: YYYY-MM-DD{" "}
                  </Text> */}
                </View>
              </View>
              <View style={{ width: "30%", borderLeft: "1px solid black" }}>
                <View>
                  <View style={{ paddingHorizontal: "12" }}>
                    <Text
                      style={{
                        fontSize: "10px",
                        fontFamily: "MyFont",
                        fontWeight: "bold",
                      }}
                    >
                      {"11) Gross weight (kg):"}
                    </Text>
                    <Text
                      style={{
                        fontSize: "10px",
                        marginTop: "5",
                        textAlign: "center",
                      }}
                    >
                      {tc?.totalGrossWeight}
                    </Text>
                  </View>
                </View>
                <View style={{ marginTop: "5", borderTop: "1px solid black" }}>
                  <View style={{ paddingHorizontal: "12" }}>
                    <Text
                      style={{
                        fontSize: "10px",
                        marginTop: "5",
                        fontFamily: "MyFont",
                        fontWeight: "bold",
                      }}
                    >
                      {"12) Net weight (kg):"}
                    </Text>
                    <Text
                      style={{
                        fontSize: "10px",
                        marginTop: "5",
                        textAlign: "center",
                      }}
                    >
                      {tc?.totalNetWeight}
                    </Text>
                  </View>
                </View>
                <View style={{ borderTop: "1px solid black" }}>
                  <View style={{ paddingHorizontal: "12" }}>
                    <Text
                      style={{
                        fontSize: "10px",
                        marginTop: "5",
                        fontFamily: "MyFont",
                        fontWeight: "bold",
                      }}
                    >
                      {"13) Certified weight (kg):"}
                    </Text>
                    <Text
                      style={{
                        fontSize: "10px",
                        marginTop: "5",
                        textAlign: "center",
                      }}
                    >
                      {tc?.totalCertifiedWeight}
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View
              style={{
                height: "100px",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ marginTop: "5", paddingHorizontal: "10" }}>
                <Text
                  style={{
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  {"14) Declaration of the body issuing the certificate:"}
                </Text>
                <Text style={{ fontSize: "10px", marginTop: "10px" }}>
                  {`This is to certify that, based on the relevant documentation provided by the seller named in box 3 (i) the [material name(s)] used for the products as further detailed / referred to in box 10 and quantified in box 11, 12 and 13 has been produced in accordance with GCC V1.0 and (ii) the products have been processed in accordance with GCC Verification Protocol. Compliance with the standard is audited and monitored systematically under responsibility of the certification body named in box 1.`}
                </Text>
              </View>
            </View>

            <View
              style={{
                height: "50px",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ marginTop: "5", paddingHorizontal: "10" }}>
                <Text
                  style={{
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  {" 15) Additional declaration: "}
                </Text>
                <Text style={{ fontSize: "10px", marginTop: "10px" }}>NA</Text>
              </View>
            </View>

            <View
              style={{
                height: "20px",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ marginTop: "3", paddingHorizontal: "10" }}>
                <Text
                  style={{
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  {" Reference Number of the certificate:"}
                </Text>
              </View>
            </View>

            <View
              style={{
                height: "35px",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ marginTop: "5", paddingHorizontal: "10" }}>
                <Text
                  style={{
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  {"16). Continuation of box 10."}
                </Text>
              </View>
            </View>

            <View
              style={{
                // height: '100px',
                borderTop: "1px solid black",
              }}
            >
              <View>
                <View
                  style={{
                    flexDirection: "row",
                    borderBottom: 1,
                    borderColor: "#000",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  <Text style={[styles.tableHeader, { width: "10%" }]}>
                    Sr No
                  </Text>
                  <Text style={[styles.tableHeader, { width: "15%" }]}>
                    Product Name
                  </Text>
                  <Text style={[styles.tableHeader, { width: "10%" }]}>
                    Packed In
                  </Text>
                  <Text style={[styles.tableHeader, { width: "15%" }]}>
                    Lot-Number
                  </Text>
                  <Text style={[styles.tableHeader, { width: "15%" }]}>
                    PR Number
                  </Text>
                  <Text style={[styles.tableHeader, { width: "10%" }]}>
                    Gross Weight (KG)
                  </Text>
                  <Text style={[styles.tableHeader, { width: "10%" }]}>
                    Net Weight (KG)
                  </Text>
                  <Text style={[styles.tableHeader, { width: "15%" }]}>
                    Certified Weight (KG)
                  </Text>
                </View>

                {tc?.products?.map((item, index) => (
                  <View style={{ flexDirection: "row" }} key={index}>
                    <Text style={[styles.tableCellTc, { width: "10%" }]}>
                      {index + 1}
                    </Text>
                    {/* <Text style={[styles.tableCellTc, { width: "15%" }]}>
                      {item?.productId?.name ? item?.productId?.name : "N/A"}
                    </Text> */}
                    <Text style={[styles.tableCellTc, { width: "15%" }]}>
                      {item?.productId?.name ? item?.productId?.name : "N/A"}
                      {item?.productId?.product_productCategory?.name
                        ? ` / ${item?.productId?.product_productCategory?.name}`
                        : ""}
                    </Text>

                    <Text style={[styles.tableCellTc, { width: "10%" }]}>
                      {item.packedIn || 0}
                    </Text>
                    <Text style={[styles.tableCellTc, { width: "15%" }]}>
                      {item.lotNumber || 0}
                    </Text>
                    <Text style={[styles.tableCellTc, { width: "15%" }]}>
                      {item?.prNumber || 0}
                    </Text>
                    <Text style={[styles.tableCellTc, { width: "10%" }]}>
                      {item?.grossWeight ? item?.grossWeight : 0}
                    </Text>
                    <Text style={[styles.tableCellTc, { width: "10%" }]}>
                      {item?.netWeight ? item?.netWeight : 0}
                    </Text>
                    <Text style={[styles.tableCellTc, { width: "15%" }]}>
                      {item?.certifiedWeight ? item?.certifiedWeight : 0}
                    </Text>
                  </View>
                ))}
              </View>
            </View>

            <View
              style={{
                height: "50px",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ marginTop: "5", paddingHorizontal: "10" }}>
                <Text
                  style={{
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                  }}
                >
                  {"17) Continuation of box 8 and box 9"}
                </Text>
              </View>
            </View>

            <View
              style={{
                height: "70px",
                flexDirection: "row",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ width: "49%" }}>
                <View style={{ paddingHorizontal: "10", marginTop: "5" }}>
                  <Text style={{ fontSize: "10px" }}>
                    {tc?.tc_consignee?.name ? tc?.tc_consignee?.name : "N/A"}
                  </Text>

                  <Text style={{ fontSize: "10px", marginTop: "5px" }}>
                    {" "}
                    {tc?.tc_consignee?.address?.raw_address
                      ? tc?.tc_consignee?.address?.raw_address
                      : "N/A"}
                  </Text>
                </View>
              </View>
              <View style={{ width: "51%", borderLeft: "1px solid black" }}>
                <View style={{ paddingHorizontal: "10", marginTop: "5" }}>
                  <Text style={{ fontSize: "10px" }}>Country</Text>
                  <Text style={{ fontSize: "10px", marginTop: "10px" }}>
                    {tc?.tc_consignee?.address?.country
                      ? tc?.tc_consignee?.address?.country
                      : "N/A"}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                height: "60px",
                borderTop: "1px solid black",
              }}
            >
              <View style={{ paddingHorizontal: "10", marginTop: "5" }}>
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={{
                      width: "33%",
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {"18) Place and date of issue"}
                  </Text>
                  <Text style={{ width: "33%", fontSize: "10px" }}>
                    {"Stamp of the issuing body "}
                  </Text>
                  <Text style={{ width: "33%", fontSize: "10px" }}>
                    {" Logo of the Scheme Owner "}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginTop: "5px" }}>
                  <Text style={{ width: "33%", fontSize: "10px" }}>
                    Navi Mumbai, {formattedDate}
                  </Text>
                  <Text
                    style={{
                      width: "33%",
                      textAlign: "center",
                      marginRight: "30px",
                    }}
                  >
                    <Image src={Cu} style={{ width: "35px", height: "35px" }} />
                  </Text>
                  <Text
                    style={{
                      width: "33%",
                      textAlign: "center",
                      marginRight: "35px",
                    }}
                  >
                    <Image
                      src={CuFoot}
                      style={{ width: "80px", height: "50px" }}
                    />
                  </Text>
                </View>
                {/* <View style={{ flexDirection: "row", marginTop: "0px" }}>
                  <View style={{ width: "33%" }}>
                    <Text style={{ fontSize: "10px" }}>
                      {"On behalf of the Managing Director,"}
                    </Text>
                    <Text style={{ fontSize: "10px" }}>{tc?.tc_approvedBy?.name},{"Certifier"} </Text>
                  </View>
                  <View style={{ width: "33%" }}>
                    <Text
                      style={{
                        width: "33%",
                        marginRight: "40px",
                      }}
                    >
                      <Image
                        src={CuTree}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </Text>
                  </View>

                </View> */}
              </View>
            </View>
          </View>
        </View>
      </PageWrapper>
    </Document>
  );
};

const TCnew = ({ tcData }) => {

  return (
    <div style={{ height: '100vh' }}>
      <PDFViewer style={{ width: '100%', height: '100%' }}>
        <MyDocument tcData={tcData} />
      </PDFViewer>
    </div>
  );
};

export default TCnew;
